import { useState } from "react";

import { ModalContainer } from "../../components/PageComponents";
import {
  OutlineButton,
  GradientButton,
  Input,
  Search,
} from "../../components/forms";
import { CloseIcon, ThreeDotsIcon } from "../../icons/promotions";
import { DeleteIcon } from "../../assets/Icons";
import { ContentProps, ContentModalProp } from "./types";

export const ContentInfo = ({ info }: { info: ContentProps[] }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ContentProps | null>(null);

  return (
    <div className="row-8 flex-wrap w-full">
      {info.map((item) => (
        <div
          key={item.id}
          className="col-4 min-w-[483px] rounded-lg border border-gray-300 p-4"
        >
          <div className="row-2 justify-between">
            <span className="inter-sm-medium-black">{item.title}</span>
            <ThreeDotsIcon />
          </div>

          <div>
            {item.content.map((content) => (
              <div
                key={content.id}
                className="row-1 items-center py-4 border-b border-gray-200"
              >
                <img
                  src={content.img}
                  alt={content.title}
                  className="w-8 h-8 rounded-md"
                />
                <span className="inter-xs-normal-gray-600">
                  {content.title}
                </span>
              </div>
            ))}
          </div>

          <div className="row-2 justify-end">
            <OutlineButton
              content="View and edit details"
              onClick={() => {
                setSelectedItem(item);
                setModalOpen(true);
              }}
            />
          </div>
        </div>
      ))}

      {modalOpen && selectedItem && (
        <ContentModal
          content={selectedItem}
          close={() => {
            setModalOpen(false);
            setSelectedItem(null);
          }}
        />
      )}
    </div>
  );
};

const ContentModal = ({ close, content }: ContentModalProp) => {
  return (
    <ModalContainer
      title={content.title}
      closeIcon={
        <button onClick={close}>
          <CloseIcon />
        </button>
      }
    >
      <div className="">
        {content.content.map((item, index) => (
          <div
            key={item.id}
            className={`flex flex-row justify-between items-center ${
              index < content.content.length - 1 && "border-b border-gray-200"
            }`}
          >
            <div className={`row-1 items-center py-4 `}>
              <img
                src={item.img}
                alt={item.title}
                className="w-8 h-8 rounded-md"
              />
              <span className="inter-xs-normal-gray-600">{item.title}</span>
            </div>
            <ThreeDotsIcon />
          </div>
        ))}

        <div className="row-2 justify-end">
          <OutlineButton content="Save changes" onClick={close} />
        </div>
      </div>
    </ModalContainer>
  );
};

export const NewContentModal = ({ close, content }: ContentModalProp) => {
  return (
    <ModalContainer
      title={content.title}
      closeIcon={
        <button onClick={close}>
          <CloseIcon />
        </button>
      }
    >
      <div className="col-8">
        <Input placeholder="Content group name" />
        <div className="col-6 p-4 bg-gray-50 rounded-2xl">
          <div className="col-1">
            <span className="satoshi-base-bold-pry-900">Products</span>
            <span className="satoshi-sm-normal-gray-600">
              Add and remove products
            </span>
          </div>
          <div className="col-8">
            <div className="row-4 w-full">
              <Search placeholder="Search for product" />
              <OutlineButton content="Add product" />
            </div>
            <div className="w-full border border-dashed"></div>
            {content.content.map((item, index) => (
              <div
                key={item.id}
                className={`flex flex-row justify-between items-center ${
                  index < content.content.length - 1 &&
                  "border-b border-gray-200"
                }`}
              >
                <div className={`row-1 items-center py-4 `}>
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-8 h-8 rounded-md"
                  />
                  <span className="inter-xs-normal-gray-600">{item.title}</span>
                </div>
                <DeleteIcon />
              </div>
            ))}
          </div>
        </div>
        <div className="row-2 justify-end">
          <GradientButton content="Create content" onClick={close} />
        </div>
      </div>
    </ModalContainer>
  );
};
